import * as React from "react"

import { ASSETS_URL } from "@/constants"
import { Box, Stack } from "@mui/material"

interface IPropertyThumbnailProps {
  src: string
}

const PropertyThumbnail: React.FunctionComponent<IPropertyThumbnailProps> = ({
  src
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        // height: [210, 230, 330],
        [`& img`]: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
        },
      }}
    >
      <img src={src || `${ASSETS_URL}/main-logo.svg`} alt="" />
    </Box>
  )
}

export default PropertyThumbnail

